import { render, staticRenderFns } from "./SamImage.vue?vue&type=template&id=09e9b81a&scoped=true&"
import script from "./SamImage.vue?vue&type=script&lang=js&"
export * from "./SamImage.vue?vue&type=script&lang=js&"
import style0 from "./SamImage.vue?vue&type=style&index=0&id=09e9b81a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9b81a",
  null
  
)

export default component.exports